import { render, staticRenderFns } from "./MarkCountByStd.vue?vue&type=template&id=a9b581d2&"
import script from "./MarkCountByStd.vue?vue&type=script&lang=js&"
export * from "./MarkCountByStd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports